import React from 'react'
import styled from 'styled-components'
import lowImg from '@/assets/imges/leak-low.png'
import centerkImg from '@/assets/imges/leak-center.png'
import highImg from '@/assets/imges/leak-high.png'
import severityImg from '@/assets/imges/leak-severity.png'
import { t } from '@/i18n'

interface RiskLevelProps {
  level: 'RiskLevelGross' | 'RiskLevelHigh' | 'RiskLevelMiddle' | 'RiskLevelLow' | string
}

const RiskLevel: React.FC<RiskLevelProps> = ({ level }) => {
  const levelConfig = {
    RiskLevelGross: { label: t('严重'), color: '#B70000', bg: '#F5D9D9', icon: severityImg },
    RiskLevelHigh: { label: t('高危'), color: '#FF4141', bg: '#FFE1E1', icon: highImg },
    RiskLevelMiddle: { label: t('中危'), color: '#FFA709', bg: '#FFEDCE', icon: centerkImg },
    RiskLevelLow: { label: t('低危'), color: '#6F9FFF', bg: '#E1EBFE', icon: lowImg },
  }

  const config = levelConfig[level as keyof typeof levelConfig] || levelConfig.RiskLevelLow

  return (
    <Container>
      <Icon src={config.icon} alt="" />
      <StyledTag bgColor={config.bg} color={config.color}>
        {config.label}
      </StyledTag>
    </Container>
  )
}

const Container = styled.span`
  display: flex;
  align-items: center;
`

const Icon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 4px;
`

const StyledTag = styled.span<{ bgColor: string; color: string }>`
  display: inline-block;
  height: 18px;
  padding: 0 4px;
  background: ${props => props.bgColor};
  border-radius: 4px;
  line-height: 18px;
  color: ${props => props.color};
  font-size: 12px;
  margin-right: 4px;
`

export default RiskLevel
